import { ElementRef, QueryList } from '@angular/core';
import { get } from 'http';
import { distinctUntilChanged, Subject } from 'rxjs';

export abstract class LazyListCompontent {
    observer = new IntersectionObserver((entries) => {
        entries.forEach(
            (entry) => {
                if (entry.isIntersecting) {
                    const lazyId = entry.target.getAttribute('data-lazyId');
                    if (lazyId) this.onNeedToLoad$.next(lazyId);
                }
            },
            { threshold: 0.1 }
        );
    });

    onNeedToLoad$ = new Subject<string>();
    get onNeedToLoad() { return this.onNeedToLoad$.pipe(distinctUntilChanged()); }

    constructor() {
    }

    setLazyItems(list: QueryList<ElementRef>) {
        list.toArray().forEach((item) => {
            this.observer.observe(item.nativeElement);
        });
    }

    abstract handleLoadLazyData(): void;
}
